import * as React from "react";
import { theme } from "../../../theme";

interface Props {
  color?: string;
}

export const DatabaseIcon: React.FC<Props> = ({
  color = theme.colors.text,
}) => (
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.33333 10.5C4.38781 10.5 2 9.6046 2 8.5"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M12.6667 3.83398V8.16732M2 3.83398V13.1673C2 14.2719 4.38781 15.1673 7.33333 15.1673C7.44527 15.1673 7.5564 15.1661 7.66667 15.1635"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M7.33333 5.83398C10.2789 5.83398 12.6667 4.93855 12.6667 3.83398C12.6667 2.72941 10.2789 1.83398 7.33333 1.83398C4.38781 1.83398 2 2.72941 2 3.83398C2 4.93855 4.38781 5.83398 7.33333 5.83398Z"
      stroke={color}
      strokeWidth="1.5"
    />
    <path
      d="M4.66602 5.83398V7.16732"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M4.66602 10.5V11.8333"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M11.3327 11.6118V12.5007M11.3327 12.5007V13.3895M11.3327 12.5007H12.2215M11.3327 12.5007H10.4438M13.9993 12.5007C13.9993 13.9734 12.8054 15.1673 11.3327 15.1673C9.85995 15.1673 8.66602 13.9734 8.66602 12.5007C8.66602 11.0279 9.85995 9.83398 11.3327 9.83398C12.8054 9.83398 13.9993 11.0279 13.9993 12.5007Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);
